export default "__VITE_ASSET__028d3bcb__"